const LOCALES = ['fr', 'en'];

// Feature checks instead of the @formatjs should-polyfill helpers: the pluralrules one pulls
// @formatjs/intl-localematcher (~60 KB) into the entry, and the locale one requires Intl Locale Info
// methods (getWeekInfo…) that Firefox lacks and that nothing here uses.
function shouldPolyfillIntl() {
    if (
        typeof window.Intl === 'undefined' ||
        typeof Intl.Locale === 'undefined' ||
        typeof Intl.PluralRules === 'undefined'
    ) {
        return true;
    }
    try {
        return (
            Intl.PluralRules.supportedLocalesOf(LOCALES).length !== LOCALES.length ||
            // Old Safari bug, same check as @formatjs/intl-pluralrules
            new Intl.PluralRules('en', { minimumFractionDigits: 2 }).select(1) === 'one'
        );
    } catch {
        return true;
    }
}

function should() {
    return (
        shouldPolyfillIntl() ||
        typeof window.IntersectionObserver === 'undefined' ||
        typeof window.ResizeObserver === 'undefined'
    );
}

export default should;
